import Translate from '~/client/shared/i18n/Translate';

const Header: FC = () => (
  <div className="grid grid-flow-col gap-4">
    <h5 className="text-moon-18 font-medium text-bulma">
      <Translate id="game-leaderboards.leaderboard" />
    </h5>
  </div>
);

export default Header;
